import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import ErrorBoundary from 'core/components/ErrorBoundary'
import { AppRoutes } from 'core/router/AppRoutes'
import { AuthProvider } from 'features/auth/presentation/context/AuthContext'
import { Toaster } from 'react-hot-toast'
import { BrowserRouter } from 'react-router-dom'
import './App.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
})

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'var(--ft-surface)',
            color: 'var(--ft-text)',
            border: '1px solid var(--ft-border)',
            borderRadius: '8px',
            fontSize: '0.875rem',
            fontWeight: 600,
            boxShadow: '0 4px 16px var(--ft-shadow)',
          },
          success: { iconTheme: { primary: 'var(--ft-status-active)', secondary: 'var(--ft-surface)' } },
          error: { iconTheme: { primary: 'var(--ft-danger)', secondary: 'var(--ft-surface)' } },
        }}
      />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </ErrorBoundary>
)

export default App
